import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
	providedIn: 'root',
})
export class LoggedInGuard  {
	constructor(private authService: AuthService, private translate: TranslocoService, private router: Router) { }

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean {
		if (this.authService.loggedIn()) {
			this.router.navigate(['/' + this.translate.getActiveLang()]);
			return false;
		} else {
			return true;
		}
	}
}
